var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-button',{staticClass:"r-delete-button",class:{ cross: _vm.cross, angular: _vm.angular, transparent: _vm.transparent },attrs:{"mini":_vm.tiny,"disabled":_vm.disabled,"type":"danger","simple":!!_vm.cross,"bold":"","icon":{
    name: _vm.cross ? 'close-delete' : 'trash',
    size: _vm.tiny ? 18 : 22,
    color: 'var(--accent-danger)'
  }},on:{"click":function($event){return _vm.beforeDelete($event)}}},[(!_vm.mini && !_vm.tiny)?_c('span',{staticClass:"r-delete-button__text"},[_vm._v(" "+_vm._s(_vm.label || _vm.$t('r-delete'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }